var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number"},_vm._l((_vm.padded ? _vm.pad(_vm.value) : _vm.value),function(integer,position){return _c('integer',{key:'hours' + '-' + position,attrs:{"value":integer,"width":_vm.width}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }